import React, {FC, ReactNode} from 'react';
import styles from './modal-container.module.scss';
import { useOutsideClick } from '../../hooks/useOutsideCLick';

interface ModalContainerProps {
    children: ReactNode;
    onClose?: () => void;
}

const ModalContainer: FC<ModalContainerProps> = ({
    children, onClose
}) => {
    const modalRef = onClose && useOutsideClick(onClose);

    return (
        <div className={styles.container}>
            <div ref={modalRef} className={styles.modal}>
                {children}
            </div>
        </div>
    );
};

export default ModalContainer;